import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_DIALOG_STIL } from './fiko-dialog-stil';
import { FikoDuzlemSecici } from './FikoDuzlemSecici';

/**
 * CATIA Point Definition (GSD wireframe) — çok-modlu nokta penceresi.
 * Tür: Koordinat (X/Y/Z) · Arası (Between, 2 nokta + oran) · Eğri Üzerinde (On Curve, çizgi + oran).
 */
@Component({
  selector: 'fikoyt-nokta-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoDuzlemSecici],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Nokta Türü</div>
      <div class="sd-row"><label>Tür</label>
        <select [ngModel]="el.noktaTip || 'koordinat'" (ngModelChange)="set('noktaTip',$event)">
          <option value="koordinat">Koordinat (X/Y/Z)</option>
          <option value="arasi">İki Nokta Arası (Between)</option>
          <option value="egriUzerinde">Çizgi Üzerinde (On Curve)</option>
          <option value="extremum">Uç Nokta (Extremum)</option>
          <option value="polarExtremum">Polar Uç (Polar Extremum)</option>
          <option value="cemberMerkez">Çember Merkezi (Circle Center)</option>
          <option value="tegetEgri">Eğri Teğeti (Tangent on Curve)</option>
          <option value="ortalama">Ortalama Nokta (Mean)</option>
          <option value="duzlemde">Düzlem Üzerinde (On Plane)</option>
          <option value="projeksiyon">Düzleme İzdüşüm (Projection)</option>
        </select>
      </div>
    </div>

    @if((el.noktaTip || 'koordinat') === 'koordinat'){
      <div class="sd-grup"><div class="sd-bas">Koordinatlar</div>
        <div class="sd-row"><label>X</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1x ?? 0" (ngModelChange)="setNum('p1x',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Y</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1y ?? 0" (ngModelChange)="setNum('p1y',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>Z</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1z ?? 0" (ngModelChange)="setNum('p1z',$event)"/><span>mm</span></div></div>
        <button class="sd-btn sd-sec" (click)="yuzeyeKoy()">🎯 Yüze / 3D'ye Tıkla (Yüzey Üstü)</button>
      </div>
    } @else if(el.noktaTip === 'arasi'){
      <div class="sd-grup"><div class="sd-bas">İki Nokta Arası</div>
        <div class="sd-row"><label>Nokta 1</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Nokta 2</label>
          <select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref2','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Oran (0-1)</label><div class="sd-num"><input type="number" min="0" max="1" step="0.05" [ngModel]="el.oran ?? 0.5" (ngModelChange)="setNum('oran',$event)"/></div></div>
        <button class="sd-btn" (click)="setNum('oran',0.5)">⊕ Orta Nokta</button>
        @if(!noktalar().length){ <div class="sd-bos">Önce 2 nokta oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'duzlemde'){
      <div class="sd-grup"><div class="sd-bas">Düzlem Üzerinde (U/V)</div>
        <div class="sd-row"><label>Düzlem</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of duzlemler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','duzlem3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>U</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1x ?? 0" (ngModelChange)="setNum('p1x',$event)"/><span>mm</span></div></div>
        <div class="sd-row"><label>V</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1y ?? 0" (ngModelChange)="setNum('p1y',$event)"/><span>mm</span></div></div>
        @if(!duzlemler().length){ <div class="sd-bos">Önce bir düzlem oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'projeksiyon'){
      <div class="sd-grup"><div class="sd-bas">Düzleme İzdüşüm</div>
        <div class="sd-row"><label>Nokta</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Düzlem</label>
          <fikoyt-duzlem-secici [element]="el" [yonetici]="yon"></fikoyt-duzlem-secici></div>
        @if(!noktalar().length){ <div class="sd-bos">Önce bir nokta oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'extremum'){
      <div class="sd-grup"><div class="sd-bas">Uç Nokta (Extremum)</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Eksen</label>
          <select [ngModel]="el.eksenTip || 'z'" (ngModelChange)="set('eksenTip',$event)">
            <option value="x">X</option><option value="y">Y</option><option value="z">Z</option>
          </select></div>
        <div class="sd-row"><label>Yön</label>
          <select [ngModel]="el.tersYon ? 'min' : 'max'" (ngModelChange)="set('tersYon',$event==='min')">
            <option value="max">Maksimum (En uzak +)</option><option value="min">Minimum (En uzak −)</option>
          </select></div>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir eğri (çizgi/çember/spline/helis) oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'polarExtremum'){
      <div class="sd-grup"><div class="sd-bas">Polar Uç (eksene en uzak/yakın)</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Eksen</label><select [ngModel]="el.eksenTip || 'z'" (ngModelChange)="set('eksenTip',$event)"><option value="x">X</option><option value="y">Y</option><option value="z">Z</option></select></div>
        <div class="sd-row"><label>Yön</label><select [ngModel]="el.tersYon ? 'min' : 'max'" (ngModelChange)="set('tersYon',$event==='min')"><option value="max">Maksimum (en uzak)</option><option value="min">Minimum (en yakın)</option></select></div>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir eğri oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'cemberMerkez'){
      <div class="sd-grup"><div class="sd-bas">Çember / Eğri Merkezi</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','cember3d')" title="3D'den seç">🎯</button></div>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir çember/eğri oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'tegetEgri'){
      <div class="sd-grup"><div class="sd-bas">Eğri Teğeti (eksene paralel)</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Teğet Ekseni</label><select [ngModel]="el.eksenTip || 'x'" (ngModelChange)="set('eksenTip',$event)"><option value="x">X</option><option value="y">Y</option><option value="z">Z</option></select></div>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir eğri oluştur.</div> }
      </div>
    } @else if(el.noktaTip === 'ortalama'){
      <div class="sd-grup"><div class="sd-bas">Ortalama Nokta (Mean)</div>
        <div class="sd-row"><label>Nokta 1</label><select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Nokta 2</label><select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref2','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Nokta 3</label><select [ngModel]="el.ref3 ?? -1" (ngModelChange)="setNum('ref3',$event)"><option [value]="-1">— (ops.) —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref3','nokta3d')" title="3D'den seç">🎯</button></div>
        @if(noktalar().length < 2){ <div class="sd-bos">Önce en az 2 nokta oluştur.</div> }
      </div>
    } @else {
      <div class="sd-grup"><div class="sd-bas">Eğri Üzerinde</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Oran (0-1)</label><div class="sd-num"><input type="number" min="0" max="1" step="0.05" [ngModel]="el.oran ?? 0.5" (ngModelChange)="setNum('oran',$event)"/></div></div>
        <button class="sd-btn" (click)="setNum('oran', 1 - (el.oran ?? 0.5))">⇅ Tersine (Reverse)</button>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir eğri oluştur.</div> }
      </div>
    }

    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoNoktaDialog implements OnDestroy {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  noktalar(): any[] { return this.yonetici?.noktaSecenekleri?.(this.element) || []; }
  egriler(): any[] { return this.yonetici?.egriSecenekleri?.(this.element) || []; }
  tumEgriler(): any[] { return this.yonetici?.tumEgriSecenekleri?.(this.element) || []; }
  duzlemler(): any[] { return this.yonetici?.duzlemSecenekleri?.(this.element) || []; }
  ref3d(anahtar: string, tip: string): void { this.yonetici?.refSecBaslat?.(this.element, anahtar, [tip], () => this.CD.markForCheck()); }
  yuzeyeKoy(): void { this.yonetici?.noktaYuzeyeKoy?.(this.element, () => this.CD.markForCheck()); }

  set(a: string, v: any): void { this.yonetici?.padGuncelle(this.element, a, v); this.CD.markForCheck(); }
  setNum(a: string, v: any): void { const n = +v; if (!isNaN(n)) this.yonetici?.padGuncelle(this.element, a, n); this.CD.markForCheck(); }
  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
